class PriceAdjuster {
  public elements: NodeListOf<HTMLElement> | null;
  public deliveryCountryInput: HTMLInputElement | null;
  public currentTaxRateInput: HTMLInputElement | null;
  public deliveryCountryCurrency: string;
  public currentTaxRate: string;

  bindings() {
    this.elements?.forEach((element) => {
      if (element.dataset.valueOnly) {
        element.innerHTML = element.dataset[`price${this.deliveryCountryCurrency.toLowerCase()}-${this.currentTaxRate.split('.')[this.currentTaxRate.split('.').length - 1]}`] || element.innerHTML;
      } else if (element.dataset.dataset) {
        element.dataset.price = element.dataset[`price${this.deliveryCountryCurrency.toLowerCase()}-${this.currentTaxRate.split('.')[this.currentTaxRate.split('.').length - 1]}`] || element.dataset.price;
      } else {
        element.innerHTML = element.dataset[`price${this.deliveryCountryCurrency.toLowerCase()}-${this.currentTaxRate.split('.')[this.currentTaxRate.split('.').length - 1]}`] || element.innerHTML;
      }
    });
  }

  cache() {
    this.elements = document.querySelectorAll('[data-price-adjuster]');
    this.deliveryCountryInput = document.querySelector('.js-ld-label input[checked]');
    this.currentTaxRateInput = document.querySelector('.js-ls-delivery-country-form input[name="currentTaxRate"]');
    this.deliveryCountryCurrency = this.deliveryCountryInput?.dataset.currency || 'EUR';
    this.currentTaxRate = this.currentTaxRateInput?.value || '0';
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default PriceAdjuster;
